import { isPlatform } from '@ionic/react';
import { useEffect, useState } from 'react';
import { PushState, useOneSignal } from '../../../hooks/OneSignalHooks';
import { ParametersProps } from '../../wizard/WizardSteps';
import { ParameterToggle } from '../ParameterToggle';

export const NotificationsParameters: React.FC<ParametersProps> = ({
  user,
  updateParameter,
  isSetLoading,
}) => {
  const { getPushSubscriptionState, toggleUserPushNotification } =
    useOneSignal();

  const [emailNotifications, setEmailNotifications] = useState<boolean>(
    user.acf.notifications ? user.acf.notifications : false
  );

  useEffect(() => {
    if (user.acf.notifications) {
      setEmailNotifications(user.acf.notifications);
    }
    isSetLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.acf.notifications]);

  const updateUserPushNotification = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // Need to reinit the setPushNotification if we don't change really the value.
    toggleUserPushNotification(event.detail.checked, user);
  };

  const changeEmailNotifications = (event) => {
    if (emailNotifications === true) {
      setEmailNotifications(false);
      updateParameter('notifications', false);
    } else {
      setEmailNotifications(true);
      updateParameter('notifications', true);
    }
  };

  return (
    <div className="text-left text-sm ion-text-wrap profile-content">
      <ul className="mt-4">
        <ParameterToggle
          title={
            isPlatform('capacitor')
              ? 'Receive push mobile notifications'
              : 'Receive push notifications'
          }
          name="notifpush"
          checked={getPushSubscriptionState === PushState.ENABLED}
          onChange={updateUserPushNotification}
          disabled={false}
        />
        <ParameterToggle
          title="Receive email notifications"
          name="notifications"
          checked={emailNotifications}
          onChange={changeEmailNotifications}
        />
      </ul>
    </div>
  );
};
